import React, { useEffect, useRef, useState } from "react";
import Ticker from 'react-ticker';
import './ticker.scss';
import { useMutation } from "@tanstack/react-query";
import { devAxios } from "../config/axiosdev.config";



const TickerComponent = () => {

    const [ticker,setTicker] = useState([]);
    const [title, setTitle] = useState("");
    const [emailVerify, setEmailverify] = useState(false);

    // const emailSet = new Set([
    // "9cdesignco@gmail.com",
    // "arishacreation@gmail.com",
    // "barbeesaa@gmail.com",
    // "bhumifashion2012@gmail.com",
    // "diwansaab1988@gmail.com",
    // "kanchinangia74@hotmail.com",
    // "kiswahclothing@gmail.com",
    // "lakshmansaw50@gmail.com",
    // "online@deyann.in",
    // "sareemall.sd@gmail.com",
    // "sejal@esikaworld.com",
    // "SUNILPAPAPA1983@GMAIL.COM",
    // "aahvandesigns@gmail.com",
    // "tinykingdomindia@gmail.com",
    // "rangpur.in@gmail.com",
    // "Info@Stylum.in",
    // "mpsilkcreation756@gmail.com",
    // "theeternaldhagamoh@gmail.com",
    // "creationnarayani105@gmail.com",
    // "sushilsareespvtltd@gmail.com",
    // "SUREKH1@HOTMAIL.COM",
    // "amohaclothing@gmail.com",
    // "tankhidesigns1@gmail.com",
    // "m4mitulshah@gmail.com",
    // "KRUSHAART@GMAIL.COM",
    // "Boxwishindia@gmail.com",
    // "wingsinternational22@gmail.com",
    // "mkmdesignco@gmail.com",
    // "ordersgcube@gmail.com",
    // "INFO@GIRNARFASHION.IN",
    // "marketing@pinapes.com",
    // "isyatextiles@gmail.com",
    // "info.njimpex@gmail.com",
    // "sabnoor@azafashions.com",
    // "mrajaykumar.pr@gmail.com",
    // "reema@aapkisakhi.com",
    // "prachithelabel@gmail.com",
    // "aarza@rachnagroup.in",
    // "adaraclothing@gmail.com",
    // "amcreations1801@gmail.com",
    // "amrfashionllp@gmail.com",
    // "anishkacreation20@gmail.com",
    // "bhargaviapparelse@gmail.com",
    // "chetansharmaamazon@gmail.com",
    // "chokhibandhanibyvibhor@gmail.com",
    // "Desirefashion0409@gmail.com",
    // "deysubir1985@gmail.com",
    // "divyesh.angarika@gmail.com",
    // "fd.kumarahul@gmail.com",
    // "gauravsehgal101@gmail.com",
    // "harsoniethnics@gmail.com",
    // "heman.bhalla@gmail.com",
    // "hemantxl@gmail.com",
    // "houseofayka@gmail.com",
    // "info@chahatcreations.com",
    // "info@desiweavess.in",
    // "info@realunreal.in",
    // "info@rechannel.co.in",
    // "infobanasuri@gmail.com",
    // "kshitij@devidesigns.in",
    // "rs19april@gmail.com",
    // "leemarconline@gmail.com",
    // "Mahotsavesolution@gmail.com",
    // "mansi.fashion001@gmail.com",
    // "manvantra1988@gmail.com",
    // "marlschuz@gmail.com",
    // "mdrustam_ali@yahoo.com",
    // "moksharchies@yahoo.com",
    // "narbhindia@gmail.com",
    // "navyug41@gmail.com",
    // "nikhaarcreations@gmail.com",
    // "onlinepriyankachaudhary@gmail.com",
    // "overnicesilk@gmail.com",
    // "Posindian675@gmail.com",
    // "pretaporter.sales@gmail.com",
    // "projectdesicolour@gmail.com",
    // "pushpalakhara@gmail.com",
    // "rahifashion2015@gmail.com",
    // "rinkyfashions@gmail.com",
    // "riteshdayal@gmail.com",
    // "rmgcbasak@gmail.com",
    // "sales.piahfashion@gmail.com",
    // "sales.sonicraftjewels@gmail.com",
    // "sales@goodbyegravity.co.in",
    // "savitakchoudhary21@gmail.com",
    // "sgrethnic@gmail.com",
    // "shivanshcreation22@gmail.com",
    // "shraddha.sarees@gmail.com",
    // "shwetajain20@gmail.com",
    // "soumyacreation02@gmail.com",
    // "spiceartcreations@gmail.com",
    // "ssethnic@gmail.com",
    // "styleroofpvtltd@gmail.com",
    // "sugaatri2013@gmail.com",
    // "tazeementerprisesvns@gmail.com",
    // "teamdivena1@gmail.com",
    // "vastraswarg@gmail.com",
    // "Vastravinodjodhpur@gmail.com",
    // "ve.varunenterprises@gmail.com",
    // "vihaaonlinesales@gmail.com",
    // "yaminikachhwaha@gmail.com",
    // "info@sheeoli.com",
    // "sri5mukha@gmail.com",
    // "sscollection.kol@gmail.com",
    // "vanshikacreationecommerce@gmail.com",
    // "sales@jobile.in",
    // "greetings@anuvas.com",
    // "maya.taparia11@gmail.com",
    // "drishti.aarambhmens@gmail.com",
    // "styleoffashiondelhi@gmail.com",
    // "thehouseofamaya@gmail.com",
    // "ecomdnd@gmail.com",
    // "info@samaayajaipur.com",
    // "vastrapink@gmail.com",
    // "admin@scakhi.com",
    // "smita.halwasiya@gmail.com",
    // "ajay.kmr13@gmail.com",
    // "dpstraders007@gmail.com",
    // "malahaindia@gmail.com",
    // "jrkenterprises0403@gmail.com",
    // "rasmbymuskaan@gmail.com",
    // "gottakinarigottakoffee@gmail.com",
    // "stockontrend01@gmail.com",
    // "aashvisinc@gmail.com",
    // "sagaweavers@gmail.com",
    // "arshajewels1@gmail.com",
    // "sales@sareeexotica.net",
    // "sehrbysupriyadhingra@gmail.com",
    // "Aeshna.parag@gmail.com",
    // "uvcreations17@gmail.com",
    // "alorakidss@gmail.com",
    // "shubham.mukutwala@hotmail.com",
    // "justinstylz1@gmail.com",
    // "accounts@tjori.com",
    // "finance@saagah.com",
    // "sanjanadesignwear@gmail.com",
    // "social.karighar@gmail.com",
    // "rahuljhunjhunwala2002@gmail.com",
    // "elancouture2012@gmail.com",
    // "sweetybakliwal77@gmail.com",
    // "silkthreadsindia@gmail.com",
    // "care@divino.in",
    // "info.wovenup@gmail.com",
    // "tahvoindia1@gmail.com",
    // "gargdesignshubhi@gmail.com",
    // "pavanfashion@yahoo.co.in",
    // "paramshah2579@gmail.com",
    // "beenu.malik12@gmail.com",
    // "hello@authentics.me",
    // "roohaniyatjaipur@gmail.com",
    // "houseofjamoti@gmail.com",
    // "krivarbyashigupta@gmail.com",
    // "info.mommyandbaby@gmail.com",
    // "somjalmahaltext@gmail.com",
    // "info@kimora.in",
    // "hathkargha001@gmail.com",
    // "couturesuman@gmail.com",
    // "agarwalpriyanka137@gmail.com",
    // "raza.hamid.2609@gmail.com",
    // "thekiddorama@gmail.com",
    // "shayamafashionhouse@gmail.com",
    // "shaurees@gmail.com",
    // "rathishruti02@gmail.com",
    // "rajoriainstyle@gmail.com",
    // "admin@kasya.in",
    // "online@simaaya.in",
    // "johori.com@gmail.com",
    // "kaashribyanupama@gmail.com",
    // "contactus.themagicwand@gmail.com",
    // "ac.pinkvillellp@gmail.com",
    // "parth@titikksha.com",
    // "dhandhiaent@gmail.com",
    // "mittal_anshu2003@yahoo.co.in",
    // "chromaticka.enterprise@gmail.com",
    // "nmfashionindia@gmail.com",
    // "lumiereartificial@gmail.com",
    // "contact@cyanindia.com",
    // "gajiwalasaree@gmail.com",
    // "vafproduction@gmail.com",
    // "pratibimbjewels@gmail.com",
    // "Miraya.agarwal08@gmail.com",
    // "ritesh@qalaonline.com",
    // "jiyadesignersjpr@gmail.com",
    // "yc@jdeals.in",
    // "info@ragavi.in",
    // "admin@aynaa.in",
    // "hotmessjewelsbykyra@gmail.com",
    // "ladojaipuriofficial@gmail.com",
    // "Sulakshacouturez@gmail.com",
    // "vridhi.tilwani@gmail.com",
    // "kishan.pkenterprises@gmail.com",
    // "Houseofajita@gmail.com",
    // "branding.minisingh@gmail.com",
    // "Santbespoke23@gmail.com",
    // "sanaita.ethnic@gmail.com",
    // "sivasathiofficial@gmail.com",
    // "rock_creation@yahoo.com",
    // "info@thekina.in",
    // "raghvendrafashion@gmail.com",
    // "thehatheli@gmail.com",
    // "cotnuf@gmail.com",
    // "Shopmamooli@gmail.com",
    // "gayatrisharma9807@gmail.com",
    // "tushposh.by.am@gmail.com",
    // "info@kkanyaah.com",
    // "yashvisanskrut@gmail.com",
    // "listing@ahalyaa.com",
    // "attire.identityformen@hotmail.com",
    // "ruhmindia@gmail.com",
    // "superlativefashiontrends@gmail.com",
    // "info@cippele.com",
    // "sainygarg.0710@gmail.com",
    // "careforearth.yana@gmail.com",
    // "Sivicallection@gmail.com",
    // "bharat.lionking@gmail.com",
    // "desiividesi.label@gmail.com",
    // "hiflyerjewels@gmail.com",
    // "info@flagbearer.co.in",
    // "contact@salwarstudio.com",
    // "badaboota@gmail.com",
    // "rfplonlinepvt@gmail.com",
    // "contact@theprintpickle.com",
    // "asheeta@chhabra555.com",
    // "kaushpallavi@gmail.com",
    // "sequinkrafts@gmail.com",
    // "Sales@jivora.in",
    // "thenukkadbride@gmail.com",
    // "clutchcraft.in@gmail.com",
    // "rathi.aarti@gmail.com",
    // "ethniccastlestudio@gmail.com",
    // "ahmedumair721@gmail.com",
    // "Whooshfashionjaipur@gmail.com",
    // "ushmaaclothing@gmail.com",
    // "contact@mieko.in",
    // "mongasdelhi@gmail.com",
    // "Prernajaya@gmail.com",
    // "as.onemanshow@gmail.com",
    // "vipul2kagrawal@rediffmail.com",
    // "aakritibhaniramka90@gmail.com",
    // "infokidsisland@gmail.com",
    // "Surbhikharkia@gmail.com",
    // "kanubajoria@hotmail.com",
    // "3stagepvtltd@gmail.com",
    // "sangeetamfashion@yahoo.co.in",
    // "info@theethnicworld.com",
    // "atulniyadesign@gmail.com",
    // "asthagrvr@gmail.com",
    // "newlook@vedantjain.in",
    // "earthofabmarketing@gmail.com",
    // "fairyplanet1@gmail.com",
    // "inspiringyan05@gmail.com",
    // "order@kaftanize.com",
    // "admin@womenue.com",
    // "ecommerce@zarijaipur.com",
    // "info@vinayfashion.com",
    // "Imrozhouse@gmail.com",
    // "grootinn@gmail.com",
    // "Info@shrutinaglabel.com",
    // "aartilakshakarsheestarsales@gmail.com",
    // "markkahbyeshagulati@gmail.com",
    // "rkbsaree@gmail.com",
    // "Kirandesignboutique@gmail.com",
    // "lumixglobaltrade@gmail.com",
    // "sidhantmittal96@gmail.com",
    // "sash@sashinternational.in",
    // "kashishkashishg123@gmail.com",
    // "Radhika@handme.co.in",
    // "info@gardinshoes.com",
    // "manishalakhotia@gmail.com",
    // "6russelstreet@gmail.com",
    // "komal.rajgaria@gmail.com",
    // "Kn@kalpananaik.in",
    // "nibhana@nibhanachawra.com",
    // "cloracreation@gmail.com",
    // "sutti.co.in@gmail.com",
    // "theweddingfashionn@gmail.com",
    // "Geetafashionbyvaibhav@gmail.com",
    // "merchandiser@esqube.in",
    // "townfaboffice125@gmail.com",
    // "Jewelsaksh@gmail.com",
    // "parvdesignstudio.social@gmail.com",
    // "sales@jamewaar.com",
    // "monjolikafashion@gmail.com",
    // "navviindia@gmail.com",
    // "poletaara24@gmail.com",
    // "contactus@labelswatiimadhukar.com",
    // "tejlivingsociety@gmail.com",
    // "Jaipurite.corp@gmail.com",
    // "evchannels@cbazaar.com",
    // "nehanandini01@gmail.com",
    // "aditriparidhanstyle@gmail.com",
    // "jeeshadesigns@gmail.com",
    // "adiwaa.uf@gmail.com",
    // "sjbslifestyleopc@gmail.com",
    // "Istylefashionandproduction2021@gmail.com",
    // "fashionreinvent@gmail.com",
    // "ANUJCREATIONSS@GMAIL.COM",
    // "mybhrata@gmail.com",
    // "juggernautbazaar@gmail.com",
    // "qalajaipur@gmail.com",
    // "gajendra30.singh@ril.com",
    // "blackthesunshine@gmail.com",
    // "designer225@yopmail.com",
    // "designer235@yopmail.com"
    // ]);

    // useEffect(() => {
    //   const userDetails = JSON.parse(localStorage.getItem("userInitDetails"));
    // const userEmail = userDetails?.user_details?.email;

    // if (userEmail && emailSet.has(userEmail)) {
    //   setEmailverify(true); 
    // }
    // },[])

  //   if (!emailVerify) {
  //   return null;
  // }

    return (
      <> 

      {/* {emailVerify && (
        <Ticker speed={5} mode="smooth"> 
          {({ index }) => (
            <div className="ticker">
              <p className="ticker-text">Cost Price update (inclusive of the revised GST) must be done through the vendor portal</p>
            </div>
          )}
        </Ticker>
    )} */}

            <Ticker speed={5} mode="smooth"> 
          {({ index }) => (
            <div className="ticker">
              <p className="ticker-text">Important Update: All orders must be shipped to Mumbai WH only. Contact your POC for details.</p>
            </div>
          )}
        </Ticker>
   </>
      ); 
}


export default TickerComponent;